<template>
  <div class="approval-dialog">
    <h2>✅ Approve Capture for Merge</h2>
    <p class="subtitle">Review and approve {{ branchName }}</p>

    <div v-if="!comparisonSummary" class="loading-summary">
      <p>Loading summary data...</p>
    </div>

    <div v-else class="summary-panel">
      <h3>Changes Summary</h3>
      <div class="summary-stats">
        <div class="stat">
          📝 Modified: {{ comparisonSummary.drift?.modified || 0 }}
        </div>
        <div class="stat">➕ Added: {{ comparisonSummary.drift?.added || 0 }}</div>
        <div class="stat">
          🗑️ Deleted: {{ comparisonSummary.drift?.deleted || 0 }}
        </div>
      </div>

      <h3>Baseline Compliance</h3>
      <div class="summary-stats">
        <div class="stat">
          ⚠️ Critical: {{ comparisonSummary.compliance?.critical || 0 }}
        </div>
        <div class="stat">⚠️ High: {{ comparisonSummary.compliance?.high || 0 }}</div>
      </div>
    </div>

    <div class="approval-form">
      <div class="form-group">
        <label>Approval Comments <span class="required">*</span></label>
        <textarea
          v-model="comments"
          rows="4"
          placeholder="Describe your review and approval decision..."
          required
        ></textarea>
        <small v-if="comments.length < 50" class="error">
          Minimum 50 characters required ({{ 50 - comments.length }} more)
        </small>
      </div>

      <div class="form-group">
        <label>
          <input type="checkbox" v-model="acknowledgeImpact" />
          I acknowledge these changes may impact users
        </label>
      </div>

      <div class="actions">
        <button class="btn-secondary" @click="$emit('back')">
          ← Back to Review
        </button>
        <button class="btn-primary" @click="approve" :disabled="!canApprove">
          Approve & Continue →
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { msalInstance } from "@/auth.js";

export default {
  name: "ApprovalDialog",

  props: {
    branchName: String,
    clientCode: String,
    comparisonSummary: Object,
  },

  data() {
    return {
      comments: "",
      acknowledgeImpact: false,
    };
  },

  computed: {
    canApprove() {
      return this.comments.length >= 50 && this.acknowledgeImpact;
    },
  },

  methods: {
    approve() {
      const accounts = msalInstance.getAllAccounts();
      const user = accounts[0]?.username || "Unknown";

      this.$emit("approve", {
        approvedBy: user,
        approvedAt: new Date().toISOString(),
        comments: this.comments,
        summary: this.comparisonSummary?.drift,
      });
    },
  },
};
</script>

<style scoped>
.approval-dialog {
  padding: 24px;
}

.approval-dialog h2 {
  margin: 0 0 8px 0;
  font-size: 20px;
}

.subtitle {
  margin: 0 0 24px 0;
  color: #666;
  font-size: 14px;
}

.summary-panel {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 24px;
}

.summary-panel h3 {
  margin: 0 0 12px 0;
  font-size: 16px;
}

.summary-stats {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.stat {
  font-size: 14px;
  font-weight: 500;
}

.approval-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  font-size: 14px;
}

.form-group textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-family: inherit;
  font-size: 14px;
}

.required {
  color: #dc3545;
}

.error {
  color: #dc3545;
  font-size: 12px;
}

.actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.btn-primary,
.btn-secondary {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.btn-primary {
  background: #007bff;
  color: white;
}

.btn-primary:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.btn-secondary {
  background: #6c757d;
  color: white;
}
</style>
